import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@skylabs-digital/backoffice-kit';
import { appsApi } from '../../api/apps.api';

const ALL = '__all__';

/** El selector "All apps / <app>" que comparten los paneles; el valor vive en la URL del que lo usa. */
export function AppFilter({
  value,
  onChange,
  className = 'w-48',
}: {
  value: string | undefined;
  onChange: (appId: string | undefined) => void;
  className?: string;
}) {
  const { data: apps } = appsApi.useList();
  return (
    <Select value={value ?? ALL} onValueChange={(v) => onChange(v === ALL ? undefined : v)}>
      <SelectTrigger className={className} aria-label="App">
        <SelectValue placeholder="All apps" />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value={ALL}>All apps</SelectItem>
        {(apps ?? []).map((a) => (
          <SelectItem key={a.id} value={a.id}>
            {a.name}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
